import React from 'react';
import { bool } from 'prop-types';
import {
  Card,
  Skeleton,
  SkeletonBlock,
  SkeletonLine,
  SkeletonContent
} from '@one-thd/sui-atomic-components';

const EndcapPodPlaceholder = ({ placeholderPodNumber, placeholderTextNumber }) => {
  return [...Array(placeholderPodNumber)].map((_placeholder, _placeholderKey) => {
    return (
      <div className="sui-w-44 sm:sui-w-56 md:sui-w-60 sui-pr-4" key={_placeholderKey}>
        <Skeleton disablePadding>
          <SkeletonContent disablePadding>
            <SkeletonBlock aspect="wide" />
            <SkeletonLine numberOfLines={placeholderTextNumber} />
          </SkeletonContent>
        </Skeleton>
      </div>
    );
  });
};

const EndcapPlaceholder = (props) => {
  const { tabClick } = props;

  let PLACEHOLDER_TAB_NUM = null;
  let PLACEHOLDER_POD_NUM = null;
  let PLACEHOLDER_TEXT_NUM = null;

  if (typeof window !== 'undefined') {
    const width = window.innerWidth;

    if (width > 0 && width <= 640) {
      PLACEHOLDER_TAB_NUM = 3;
      PLACEHOLDER_POD_NUM = 4;
      PLACEHOLDER_TEXT_NUM = 4;
    } else if (width >= 640 && width <= 1024) {
      PLACEHOLDER_TAB_NUM = 5;
      PLACEHOLDER_POD_NUM = 6;
      PLACEHOLDER_TEXT_NUM = 5;
    } else {
      PLACEHOLDER_TAB_NUM = 7;
      PLACEHOLDER_POD_NUM = 7;
      PLACEHOLDER_TEXT_NUM = 5;
    }
  }

  if (tabClick) {
    return (
      <div className="sui-w-full" data-component="EndcapTabPlaceholder">
        <div className="sui-grow">
          <div className="endcap-placeholder-pods sui-flex sui-overflow-hidden sui-py-4">
            <EndcapPodPlaceholder
              placeholderPodNumber={PLACEHOLDER_POD_NUM}
              placeholderTextNumber={PLACEHOLDER_TEXT_NUM}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <Card
      className="endcap sui-w-full sui-border-none"
      disablePadding
      disableGutters
      data-component="EndcapPlaceholder"
    >
      <div className="sui-flex sui-flex-col sui-gap-6 sui-pt-4 sui-pb-12">
        <div className="sui-grow">
          <div
            className="endcap-placeholder-title sui-flex sui-flex-col md:sui-flex-row md:sui-justify-between
            sui-overflow-hidden sui-w-full sui-gap-2"
          >
            <div className="sui-w-72 sm:sui-w-96">
              <SkeletonLine />
            </div>
            <div className="sui-w-36 sui-h-10">
              <SkeletonBlock />
            </div>
          </div>
        </div>
        <div className="sui-grow">
          <div className="endcap-placeholder-tabs
          sui-flex sui-overflow-hidden"
          >{[...Array(PLACEHOLDER_TAB_NUM)].map((idx, idxKey) => {
              return (
                <div className="sui-w-52 sui-pr-4" key={idxKey}>
                  <SkeletonLine fullWidth variant="heading" />
                </div>
              );
            })}
          </div>
          <div className="endcap-placeholder-pods sui-flex sui-overflow-hidden sui-py-5">
            <EndcapPodPlaceholder
              placeholderPodNumber={PLACEHOLDER_POD_NUM}
              placeholderTextNumber={PLACEHOLDER_TEXT_NUM}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

export { EndcapPlaceholder };

EndcapPlaceholder.propTypes = {
  tabClick: bool
};

EndcapPlaceholder.defaultProps = {
  tabClick: null
};
